import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledText = styled.p`
  margin-bottom: 16px;
  word-break: break-word;
`;
